import { X, UserPlus, Send, Check } from "lucide-react";
import Dropdown from "../../../Components/CustomDropdown/customdropdown";
import { useState, useMemo, useRef, useEffect } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useToast } from "../../../Utils/toastContext";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const mockPeople = [
  { id: "u1", name: "Alex Johnson" },
  { id: "u2", name: "Priya Patel" },
  { id: "u3", name: "Sam Lee" },
];

const roles = [
  { value: "1", label: "Signer" },
  { value: "2", label: "Viewer" },
];

export default function AssignDrawer({
  contract,
  onClose,
  onDone,
  isBack,
  setBack,
}) {
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [roleMap, setRoleMap] = useState({});
  const [search, setSearch] = useState("");
  const [users, setUsers] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [showRecords, setShowRecords] = useState(10);
  const { showToast } = useToast();
  const { customerId, transactionId, contractId } = useParams();

  const [preselectedAccountType, setpreselectedAccountType] = useState({
    value: "1",
    label: "Signer",
  });
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      "Content-Type": "application/json",
    };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later",
      );
    }
  };
  const getUsers = async (page = 1, searchText = "") => {
    try {
      setLoadingUsers(true);

      const response = await GetAPIcalls(
        `/api/v1/agent/customers/${customerId}/client-deals/${transactionId}/contracts/available-signers`,
      );

      if (response.status === 200) {

        setUsers(response.data.signers || []);


      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      setLoadingUsers(false);
    }
  };
  useEffect(() => {
    setCurrentPage(1);
    getUsers(1, search);
  }, [search]);

  useEffect(() => {
      getUsers(currentPage, search);
    
  }, [customerId, transactionId]);
  const filteredPeople = mockPeople.filter((p) =>
    p.name.toLowerCase().includes(search.toLowerCase()),
  );
  const handleSelectAccountType = (selectedOption) => {
    console.log("Selected Option:", selectedOption.value);
  };
  function addUser(user) {
    if (selectedUsers.find((u) => u.user_id === user.user_id)) return;

    setSelectedUsers([...selectedUsers, user]);
    setRoleMap((prev) => ({
      ...prev,
      [user.user_id]: "Signer",
    }));
  }

  function removeUser(id) {
    setSelectedUsers(selectedUsers.filter((u) => u.user_id !== id));

    const updated = { ...roleMap };
    delete updated[id];
    setRoleMap(updated);
  }

  function updateRole(id, role) {
    setRoleMap((prev) => ({
      ...prev,
      [id]: role,
    }));
  }

  function handleSend() {
    console.log("Assigned:", selectedUsers, roleMap);
    onDone?.({ selectedUsers });
  }

  return (
    <Modal
      title={contract?.title || "Assign Contract"}
      // title="Assign Contract (Oak Residency Lease)"
      className="max-w-6xl"
      onClose={() => onClose()}
    >
      <div className="p-4 space-y-4">
        {/* SEARCH */}
     <UserMultiSelect
  users={users}
  selectedUsers={selectedUsers}
  setSelectedUsers={setSelectedUsers}
/>

        {/* SELECTED USERS */}
        {selectedUsers.length > 0 && (
          <div className="mt-4 space-y-3">
            <h3 className="text-xs font-semibold text-gray-500 uppercase">
              Assigned People
            </h3>

            {selectedUsers.map((u) => (
              <div
                key={u.user_id}
                className="flex items-center justify-between bg-gradient-to-r from-[#EEF2FF] to-white border rounded-xl p-3"
              >
                {/* USER */}
                <div>
                  <div className="text-sm font-medium text-gray-800">
                    {u.name}
                  </div>
                </div>

                {/* ROLE + REMOVE */}
                <div className="flex items-center gap-2">
                  <button
                    onClick={() => removeUser(u.user_id)}
                    className="text-red-500 hover:text-red-700 text-sm"
                  >
                    ✕
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* ACTIONS */}
        <div className="pt-4 flex gap-2 border-t">
          {isBack && (
            <button
              onClick={setBack}
              className="flex-1 border rounded-xl py-2 hover:bg-gray-50"
            >
              Back
            </button>
          )}
          <button
            onClick={onClose}
            className="flex-1 border rounded-xl py-2 hover:bg-gray-50"
          >
            Cancel
          </button>

          <button
            onClick={handleSend}
            disabled={!selectedUsers.length}
            className="flex-1 bg-[#375AE7] text-white rounded-xl py-2 disabled:opacity-40 hover:bg-[#375AE7]"
          >
            Send
          </button>
        </div>
      </div>
    </Modal>
  );
}

function UserMultiSelect({
  users = [],
  selectedUsers,
  setSelectedUsers,
}) {
  const [query, setQuery] = useState("");
  const [open, setOpen] = useState(false);
  const ref = useRef();

  const filtered = useMemo(() => {
    return users.filter(
      (u) =>
        u.name?.toLowerCase().includes(query.toLowerCase()) &&
        !selectedUsers.find((s) => s.user_id === u.user_id)
    );
  }, [query, users, selectedUsers]);

  function addUser(user) {
    setSelectedUsers((prev) => [...prev, user]);
    setQuery("");
  }

  function removeUser(id) {
    setSelectedUsers((prev) =>
      prev.filter((u) => u.user_id !== id)
    );
  }

  // close on outside click
  useEffect(() => {
    function handleClick(e) {
      if (!ref.current?.contains(e.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClick);
    return () =>
      document.removeEventListener("mousedown", handleClick);
  }, []);

  return (
    <div ref={ref} className="relative">
      {/* INPUT */}
      <div
        onClick={() => setOpen(true)}
        className="flex flex-wrap items-center gap-2 border rounded-xl px-3 py-2 bg-white focus-within:ring-2 focus-within:ring-[#375AE7]"
      >
        <UserPlus size={16} className="text-gray-400" />

        {/* SELECTED CHIPS */}
        {selectedUsers.map((u) => (
          <div
            key={u.user_id}
            className="flex items-center gap-1 bg-[#EEF2FF] text-[#375AE7] px-2 py-1 rounded-lg text-xs"
          >
            {u.name}
            <button onClick={() => removeUser(u.user_id)}>✕</button>
          </div>
        ))}

        <input
          value={query}
          onChange={(e) => {
            setQuery(e.target.value);
            setOpen(true);
          }}
          placeholder="Search users..."
          className="flex-1 outline-none text-sm min-w-[120px]"
        />
      </div>

      {/* DROPDOWN */}
      {open && (
        <div className="absolute z-50 mt-2 w-full bg-white border rounded-xl shadow-lg max-h-64 overflow-y-auto">
          
          {filtered.length > 0 ? (
            filtered.map((u) => (
              <div
                key={u.user_id}
                onClick={() => addUser(u)}
                className="flex items-center justify-between px-3 py-2 hover:bg-blue-50 cursor-pointer"
              >
                <span className="text-sm">{u.name}</span>
                <Check size={14} className="text-[#375AE7]" />
              </div>
            ))
          ) : (
            <div className="text-center py-3 text-xs text-gray-400">
              No more users
            </div>
          )}

        </div>
      )}
    </div>
  );
}
function Modal({ title, children, onClose, className = "" }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <div
        className={`
          bg-white rounded-2xl shadow-2xl
          w-full max-w-4xl h-[85vh]
          flex flex-col overflow-hidden
          ${className}
        `}
      >
        {/* HEADER */}
        <div className="flex justify-between items-center p-4 border-b shrink-0 bg-white">
          <h2 className="font-semibold text-gray-800">{title}</h2>
          <button
            onClick={onClose}
            className="hover:bg-gray-100 p-2 rounded-lg"
          >
            ✕
          </button>
        </div>

        {/* BODY (ONLY SCROLL HERE) */}
        <div className="flex-1 overflow-y-auto">{children}</div>
      </div>
    </div>
  );
}